import { uploadMinioFile } from '@/api/file'
import { SUCCESS_CODE } from '@/constants'
import { UploadRequestOptions } from 'element-plus'

// 后端上传地址
export const getUploadUrl = (): string => {
  return `${import.meta.env.VITE_API_SERVER_PATH}/common/upload`
}

export const useUpload = () => {
  const uploadUrl = getUploadUrl()
  // 重写ElUpload的httpRequest文件上传方法
  const httpRequest = async (options: UploadRequestOptions) => {
    return new Promise((resolve, reject) => {
      uploadMinioFile({ file: options.file })
        .then((res) => {
          if (res?.code === SUCCESS_CODE) {
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch((res) => {
          reject(res)
        })
    })
  }

  return {
    uploadUrl,
    httpRequest
  }
}
